import AdminTemplateApis from "./Admin/Templates";
import Video09Apis from './Admin/video09'
import VideosApis from "./Videos";
import PaymentsApis from "./Payments"
import ProviderApis from './Provider'
import MusicApis from './Music'
import UsersApis from './Users'
import TemplatesApis from './Templates'
import AdminDashboardApis from './Admin/dashboard'
import AdminAuthApis from './Admin/Auth'
import AdminSystemApis from "./Admin/System"
import PopupsApis from "./Popups";
import CreditsApis from "./Credits";
import MySourceApis from "./MySource";
import AiApis from "./Ai";
import AiSourcesApis from "./AiSources";
import ShortsApis from "./Shorts";

export {
    AdminTemplateApis,
    VideosApis,
    PaymentsApis,
    ProviderApis,
    MusicApis,
    Video09Apis,
    UsersApis,
    TemplatesApis,
    AdminDashboardApis,
    AdminAuthApis,
    AdminSystemApis,
    PopupsApis,
    CreditsApis,
    MySourceApis,
    AiApis,
    AiSourcesApis,
    ShortsApis,
}